import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLink, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonWrapper } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkProps } from "@insite/mobius/Link";
import Select from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import parse from "html-react-parser";
import React from "react";
import { css } from "styled-components";

const enum fields {}

interface OwnProps extends WidgetProps {
    fields: {};
}

type Props = OwnProps;

export interface SurGitMarketFormStyles {
    container?: InjectableCss;
    ctacontainer?: InjectableCss;
    title?: InjectableCss;
    descStyles?: InjectableCss;
    ctaLink?: LinkProps;
    formHeader?: InjectableCss;
    formContainer?: InjectableCss;
    userInformationGridItem?: GridItemProps;
    formTextField?: TextFieldPresentationProps;
    buttonWrapper?: InjectableCss;
    button?: InjectableCss;
}
export const surGitMarketFormStyles: SurGitMarketFormStyles = {
    container: {
        css: css`
            margin: 0 auto;
            padding: 60px 0px;
            background-color: ${getColor("common.backgroundContrast")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 20px;
                    `,
                    css`
                        padding: 20px;
                    `,
                    css`
                        padding: 20px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    formHeader: {
        css: css`
            font-family: "Mulish";
            font-style: normal;
            font-weight: 600;
            font-size: 26px;
            line-height: 34px;
            text-align: center;
            color: ${getColor("text.main")};
            margin-bottom: 30px;
        `,
    },
    formContainer: {
        css: css`
            width: 100%;
            display: grid;
            max-width: 738px;
            margin: 0 auto;
            grid-template-columns: 1fr 1fr;
            column-gap: 18px;
            row-gap: 18px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        grid-template-columns: 1fr;
                    `,
                    css`
                        grid-template-columns: 1fr;
                    `,
                    css`
                        grid-template-columns: 1fr 1fr;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    userInformationGridItem: {
        width: 12,
        css: css``,
    },
    formTextField: {
        labelProps: {
            css: css`
                font-family: "Mulish";
                font-style: normal;
                font-weight: 700 !important;
                font-size: 14px;
                line-height: 22px;
                color: ${getColor("text.main")};
                text-transform: capitalize;
            `,
        },
    },
    buttonWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 30px;
        `,
    },
    button: {
        css: css`
            padding: 10px 34px;
            span {
                font-family: "Mulish";
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 24px;
                color: #ffffff;
            }
        `,
    },
};

const styles = surGitMarketFormStyles;

const SurGitMarketForm: React.FC<Props> = ({ fields, id }) => {
    const options = ["One", "Two", "Three", "Four", "Five"];

    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.formHeader}>Fill To Register</StyledWrapper>
            <StyledWrapper {...styles.formContainer}>
                <GridItem {...styles.userInformationGridItem}>
                    <TextField
                        {...styles.formTextField}
                        label={translate("First Name:")}
                        data-test-selector="surGiftMarket_firstName"
                        required
                        type="text"
                    />
                </GridItem>
                <GridItem {...styles.userInformationGridItem}>
                    <TextField
                        {...styles.formTextField}
                        label={translate("last Name:")}
                        type="text"
                        data-test-selector="surGiftMarket_lastName"
                        maxLength={256}
                        required
                    />
                </GridItem>
                <GridItem {...styles.userInformationGridItem}>
                    <TextField
                        {...styles.formTextField}
                        type="email"
                        label={translate("Email:")}
                        data-test-selector="surGiftMarket_email"
                        required
                        maxLength={256}
                    />
                </GridItem>
                <GridItem {...styles.userInformationGridItem}>
                    <TextField
                        {...styles.formTextField}
                        label={translate("Phone")}
                        type="number"
                        data-test-selector="surGiftMarket_phone"
                    />
                </GridItem>
                <GridItem {...styles.userInformationGridItem}>
                    <TextField
                        {...styles.formTextField}
                        label={translate("Company")}
                        type="text"
                        maxLength={256}
                        data-test-selector="surGiftMarket_company"
                    />
                </GridItem>
                <GridItem {...styles.userInformationGridItem}>
                    <Select label={translate("Business Type*")} data-test-selector="surGiftMarket_bussinesType">
                        <option>--Select--</option>
                        {options.map((option, index) => {
                            // eslint-disable-next-line react/no-array-index-key
                            return <option key={index}>{option}</option>;
                        })}
                    </Select>
                </GridItem>
                <GridItem {...styles.userInformationGridItem}>
                    <TextField
                        {...styles.formTextField}
                        label={translate("ZipCode")}
                        type="number"
                        maxLength={8}
                        data-test-selector="surGiftMarket_zipcode"
                    />
                </GridItem>
                <GridItem {...styles.userInformationGridItem}>
                    <Select label={translate("Country*")} data-test-selector="surGiftMarket_country">
                        <option>--Select--</option>
                        {options.map((option, index) => {
                            // eslint-disable-next-line react/no-array-index-key
                            return <option key={index}>{option}</option>;
                        })}
                    </Select>
                </GridItem>
            </StyledWrapper>
            <StyledWrapper {...styles.buttonWrapper}>
                <Button {...styles.button}>Submit</Button>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const SurGitMarketFormWidget: WidgetModule = {
    component: SurGitMarketForm,
    definition: {
        group: "Common",
        displayName: "SurGitMarketForm",
        fieldDefinitions: [],
    },
};
export default SurGitMarketFormWidget;
